import http from "infra/http";
import { useMutation } from "react-query";

function useTogglePessoasStatus(unidadeId: string) {
  return useMutation(
    `/v1/unidade/${unidadeId}/pessoas/mudar-status`,
    async (params: { id: string }) =>
      http.put(
        `/v1/unidades/${unidadeId}/pessoas/${params.id}/mudar-status`
      )
  );
}

export default useTogglePessoasStatus;
